export enum LoyaltyError {
  NoCode = 'no-code',
  CodeClaimed = 'already-claimed',
}
